var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232,64H208V56a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,56v8H23.87305a16.01833,16.01833,0,0,0-16,16V96a40.04583,40.04583,0,0,0,40,40H51.917c9.64258,29.93658,36.14258,52.34668,68.083,55.58276V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.60626A80.12,80.12,0,0,0,204.34521,136H208a40.04584,40.04584,0,0,0,40-40V80A16.01833,16.01833,0,0,0,232,64ZM47.87305,120a24.0275,24.0275,0,0,1-24-24V80H48v31.0957A81.777,81.777,0,0,0,48.499,120ZM232,96a24.0275,24.0275,0,0,1-24,24h-.39209q.39037-3.96176.39209-8V80h24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.c7cd84408fa0b89bc17c3438e9769953.svg";
export { ForwardRef as ReactComponent };